<template>
  <div class="videoContent">
    <!-- <iframe
      id="video"
      :src="form.url"
      frameborder="0"
      class="videobox"
    ></iframe> -->
    <div class="swiper-box">
      <div class="bswiper">
        <div class="thumbs-box">
          <div id="thumbs">
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in swiper_img"
                :key="index"
                class="swiper-slide"
                :class="
                  activeIndex === index ? 'swiper-slide-thumb-active' : ''
                "
              >
                <img :src="item.pic" alt="" />
                <p>{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="center-line">
          <div class="light-line"></div>
        </div>

        <div class="right-swiper-box flex">
          <div class="swiper-container swiper-container-video">
            <div class="swiper-wrapper" v-if="swiper_img.length > 0">
              <div
                v-for="(item, index) in swiper_img"
                :key="index"
                class="swiper-slide"
              >
                <!-- <img :src="item" alt="" /> -->
                <iframe
                  id="video"
                  :src="item.videoUrl"
                  frameborder="0"
                  class="videobox"
                ></iframe>
              </div>
            </div>
          </div>
          <!-- 导航按钮 -->
          <div class="swiper-button-prev swiper-button-prev_1"></div>
          <div class="swiper-button-next swiper-button-next_1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getLdsmmWlwPestSum } from "@/api/main";
import "swiper/dist/css/swiper.css";
import "swiper/dist/js/swiper.min";
import Swiper from "swiper";
import { get } from "@/api/index";
export default {
  data() {
    return {
      activeIndex: 0,
      form: {
        url:
          "./html/stream_rtmp_view.html?rtmp=http://hls01open.ys7.com/openlive/3cb45886808446b1a385ee109f6b1596.m3u8",
      },
      swiper_img: [],
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      get("/api/restful/getWlwVideoALL", { size: 10 }).then((res) => {
        this.swiper_img = res.data.map((e) => {
          if (process.env.NODE_ENV === "prod1") {
            e.url = e.url.replace(
              window.__config.spUrl,
              "https://" + location.host + "/mm/m-screen/zt/zlcy"
            );
            e.url = e.url.replace(
              window.__config.spUrl_1,
              "https://" + location.host + "/mm/m-screen/zt/zlcy"
            );
            e.url = e.url.replace(
              "http://hls01open.ys7.com",
              "https://" + location.host + "/mm/m-screen/zt/zlcy"
            );
          }

          if (e.pic) {
            // let arr = JSON.parse(e.pic.replace("/", "//"));
            let src = window.__config.VUE_APP_IMG_URL + e.pic;
            return {
              pic: src,
              name: e.name,
              videoUrl: "./html/player.html?rtmp=" + e.url,
            };
          } else {
            return {
              pic: require("@/assets/images/video/tp/5.png"),
              name: e.name,
              videoUrl: "./html/player.html?rtmp=" + e.url,
              // videoUrl: e.url
            };
          }
        });
        console.log("video list ==", res, this.swiper_img);

        this.$nextTick(() => {
          this.initSwiper();
        });
      });
    },
    initSwiper() {
      this.$nextTick(function() {
        this.myswiper = new Swiper(".swiper-container-video", {
          // autoplay: 2500, // 可选选项，自动滑动
          navigation: {
            nextEl: ".swiper-button-next_1",
            prevEl: ".swiper-button-prev_1",
          },
          thumbs: {
            swiper: {
              el: "#thumbs",
              spaceBetween: 10,
              slidesPerView: 3,
              observer: true,
              direction: "vertical",
              watchSlidesVisibility: true /* 避免出现bug*/,
              centeredSlides: false,
            },
          },
          on: {
            slideChange: () => {
              this.activeIndex = this.myswiper.activeIndex;
            },
          },
        });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.videoContent
  height 100%
  padding 12px
  box-sizing border-box
  .videobox
    width 100%
    height 100%

.swiper-box
      height 100%
      // margin-top 16px
      .bswiper
        display flex
        width 100%
        height 100%
        padding 0 10px
        box-sizing border-box
        .thumbs-box
          height 100%
          display flex
          align-items center
          #thumbs
            width 120px
            height 100%
            overflow hidden
            .swiper-wrapper
              >>>.swiper-slide
                width 110px
                // height 62px !important
                opacity 0.6
                margin-bottom 10px
                position relative
                img
                  width 110px
                  height 100%
                  cursor pointer
                  // height 62px
                >p
                  position absolute
                  bottom 0
                  left 0
                  width 100%
                  color #fff
                  font-size 12px
                  padding 2px
                  box-sizing border-box
                  background-color rgba(0,0,0,.4)
              >>>.swiper-slide-thumb-active
                opacity 1
              >>>.swiper-slide-active
                opacity 1
        .right-swiper-box
          width calc(100% - 120px)
          height 100%
          position relative
          margin-left 10px
          // background #041649
          // border-right 4px solid #00aeff
          // border-left 4px solid #00aeff
          .swiper-title
            line-height 40px
            font-size 16px
            text-align center
            color #fff
          .swiper-container
            width 260px
            // height 100%
            height 70%
            >>>.swiper-wrapper
                .swiper-slide
                  img
                    width 260px
                    height 190px
          .swiper-button-prev,.swiper-button-next
            width 6px
            height 12px
            margin-top 14px
          .swiper-button-prev:after, .swiper-button-next:after
            display none
          .swiper-button-prev
            left 4px
            background url('~images/zhwl/next-btn.png') no-repeat center
            background-size 100% 100%
          .swiper-button-next
            right 4px
            background url('~images/zhwl/prev-btn.png') no-repeat center
            background-size 100% 100%
  .center-line
    position relative
    width 1px
    height 100%
    background #0559a3
    .light-line
      position absolute
      top 50%
      left 0
      width 1px
      height 97px
      margin-top -48.5px
      background #00aeff
</style>
